/**
 * 서비스 팝업의 화면 글 · 빈도 값 — 판정은 `pickServicePopup`(`service-popup.ts`).
 */

/** 체험 팝업을 세우는 남은 날(D-3 · D-2 · D-1 · 당일) */
export const SERVICE_POPUP_TRIAL_DAYS = 3;

/** 계정 연동 끊김 팝업의 간격 — 7일에 한 번 */
export const SERVICE_POPUP_ACCOUNT_GAP_MS = 7 * 24 * 60 * 60 * 1000;

/** 서비스에 머문 뒤 팝업을 고르기까지 — 하려던 것을 먼저 보게 둔다 */
export const SERVICE_POPUP_DWELL_MS = 30 * 1000;

/** 다른 창이 떠 있어 미뤘을 때 다시 보는 간격 */
export const SERVICE_POPUP_RETRY_MS = 2 * 1000;

/** 갈래마다 화면 글 — 체험 장의 날짜 글은 `toServicePopupCopy` 가 짓는다 */
export const SERVICE_POPUP_COPY = {
  trial: {
    offerLabel: '결제 혜택',
    close: '닫기',
    primary: '혜택 받고 결제하기',
    /** 혜택을 이미 받은 워크스페이스 */
    primaryPlain: '요금제 보기',
  },
  setup: {
    title: '아직 설정한 것이 없어요',
    body: '등록하면 언급을 빠짐없이 추적해요.',
    steps: [
      { name: '우리 브랜드', hint: '매일 언급 수와 반응 큰 글' },
      { name: '자사 계정', hint: '우리 계정이 올린 글' },
      { name: '지켜볼 대상', hint: '경쟁 브랜드 · 키워드 · 계정' },
      { name: '알림', hint: '매일 · 매주 이메일' },
    ],
    close: '나중에 할게요',
    primary: '초기 설정하기',
    never: '다시 보지 않기',
  },
  account: {
    title: '인스타그램 연동이 끊겼어요',
    body: '스토리 수집이 멈췄어요.',
    close: '닫기',
    primary: '다시 연동하기',
  },
} as const;

/** 갈래마다 머리 그림 · 색 */
export const SERVICE_POPUP_ICON = {
  trial: { icon: 'solar:hourglass-line-linear', bg: 'primary.lighter', color: 'primary.dark' },
  setup: { icon: 'solar:tuning-2-linear', bg: 'primary.lighter', color: 'primary.dark' },
  account: { icon: 'solar:unlink-linear', bg: 'warning.lighter', color: 'warning.darker' },
} as const;

/** 끊긴 계정 줄의 인스타그램 그림 */
export const SERVICE_POPUP_INSTAGRAM_ICON = 'socials:instagram';
